import React, { useContext } from "react";
import "./Review.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Review1 from "../../img/img1.jpg";
import Review2 from "../../img/img2.jpg";
import Review3 from "../../img/img3.jpg";
import Review4 from "../../img/img4.jpg";
import { themeContext } from "../../Context";
const Review = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="review" id="review">
      {/* heading */}
      <span style={{ color: darkMode ? "#b0d12a" : "" }}>Usage Reviews</span>
      <span>Virtual Reality Camera</span>

      {/* slider */}
      <Swiper spaceBetween={30} slidesPerView={3} grabCursor={true} className="review-slider">
        <SwiperSlide>
          <img src={Review1} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Review2} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Review3} alt="" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={Review4} alt="" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Review;
